export default "/app/themes/macleod/public/images/arrow-left.svg?03db1c070a71c158565e6674dd1ccfa5";